<template>
  <cac-page>
    <banner-section
      :page-key="componentUniqueKey"
      :wrapper-form-button-text="$t('cac.app.find_my_candidates')">
      <template slot="left-wrapper">
        <cac-page-header
          slot="pre-content"
          :title="actionTitle"
        />
        <div class="d-flex flex-column align-items-md-start">
          <span class="mt-2 page-section--banner__subtitle">{{ actionHelpText }}</span>
        </div>
      </template>
    </banner-section>
  </cac-page>
</template>

<script>
import { mapState } from "vuex";
import CacPage from "CivicActionCenterComponents/layout/CACPage.vue";
import CacPageHeader from "CivicActionCenterComponents/layout/CACPageHeader.vue";
import BannerSection from "CivicActionCenterComponents/shared/BannerSection.vue";
import SharedMixin from "JS/mixins/campaign/civicactioncenter/shared";
import STATE from "Constants/campaign/civicactioncenter/state";
import { isEmpty as _isEmpty } from "lodash";

export default {
  name: "CandidatesBanner",
  components: {
    CacPage,
    CacPageHeader,
    BannerSection
  },
  mixins: [SharedMixin],
  computed: {
    ...mapState(STATE.SCOPE_CAMPAIGN, ["cacFindCandidates"]),
    actionTitle() {
      return !_isEmpty(this.cacFindCandidates.cta)
        ? this.cacFindCandidates.cta
        : this.$t("cac.app.find_your_candidates");
    },
    actionHelpText() {
      return !_isEmpty(this.cacFindCandidates.description)
        ? this.cacFindCandidates.description
        : this.$t("cac.app.learn_more_about_candidates");
    }
  }
};
</script>
